module.exports = __webpack_public_path__ + "media/images/icon-think-4b5e10979e14f22fa970dea9a1521d49.svg";